function compare(a, b, dir) {
  if (dir === 'ASCENDING') {
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
  }
  if (dir === 'DESCENDING') {
    if (a > b) return -1;
    if (a > b) return 1;
    return 0;
  }
}

export default (sourceArray, propertyName, direction) => {
  if (!sourceArray || !Array.isArray(sourceArray)) {
    //not an array
    return [];
  }

  const get = propertyName === null ? (x) => x : (x) => x?.[propertyName];

  return sourceArray.sort((elA, elB) => {
    const a = get(elA);
    const b = get(elB);
    if (isNaN(a?.replace(',', '.')) || isNaN(b?.replace(',', '.'))) {
      const dateA = Date.parse(a);
      const dateB = Date.parse(b);
      if (dateA && dateB) {
        return compare(dateA, dateB, direction);
      }
      if (typeof a === 'string' && typeof b === 'string') {
        return compare(a.toUpperCase(), b.toUpperCase(), direction);
      }
      return compare(a, b, direction);
    }
  });
};
